import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { testConnection } from './Connections';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

const OAuthCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = params.get('code');
    if (!code) {
      const msg = 'Missing OAuth authorization code.';
      toast.error(msg);
      return navigate('/myconnections', {
        replace: true,
        state: { errorMessage: msg },
      });
    }

    const stored = sessionStorage.getItem('pendingOAuthConnection');
    if (!stored) {
      const msg = 'OAuth state lost. Please retry.';
      toast.error(msg);
      return navigate('/myconnections', {
        replace: true,
        state: { errorMessage: msg },
      });
    }

    const key = `__submitted_oauth_${code}`;
    if (sessionStorage.getItem(key)) return; // prevent duplicate submission
    sessionStorage.setItem(key, 'true');

    const parsed = stored ? JSON.parse(stored) : {};

    const {
      connectionName,
      connector,
      clientID,
      clientSecret,
      instanceUrl,
      redirectUri,
      authType,
      // environment,
    } = parsed;

    console.log('oAuth callback stored:::', parsed);

    let environment = parsed.environment;

    if (!environment) {
      const state = params.get('state');
      try {
        if (state) {
          const decoded = JSON.parse(atob(state));
          console.log('CALLBACK decoded state:', decoded);

          if (decoded.env) environment = decoded.env;
        }
      } catch (e) {
        console.warn('Failed to parse OAuth state', e);
      }
    }

    console.log('oAuth callback resolved env:', environment);

    const payload = {
      user_id: Cookies.get('userId'),
      conn_name: connectionName,
      connector_name: connector,
      custom_params: { instance_url: instanceUrl },
      api_version: null,
      auth: {
        type: authType || 'OAuth2',
        oauth2: {
          grant_type: 'authorization_code',
          client_id: clientID,
          client_secret: clientSecret,
          auth_code: code,
          redirect_uri: redirectUri,
          instance_url: instanceUrl,
        },
      },
      environment,
    };

    testConnection(payload)
      .then((res) => {
        const data = res?.data ?? res;
        console.log('CALLBACK backend response:', data);

        const errMsg = data?.detail || data?.error || data?.message;
        if (errMsg) {
          toast.error(`OAuth test failed: ${errMsg}`, { autoClose: 3000 });
          sessionStorage.removeItem('pendingOAuthConnection');
          return navigate('/myconnections', {
            replace: true,
            state: { errorMessage: errMsg },
          });
        }

        if (data?.test_status) {
          toast.success('OAuth connection successful!', { autoClose: 2000 });
        } else {
          toast.warning('OAuth test returned no status.');
        }
        sessionStorage.removeItem('pendingOAuthConnection');
        navigate('/myconnections', { replace: true });
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.detail ||
          err?.message ||
          'OAuth connection failed.';
        toast.error(`OAuth test failed: ${msg}`, { autoClose: 3000 });
        sessionStorage.removeItem('pendingOAuthConnection');
        navigate('/myconnections', {
          replace: true,
          state: { errorMessage: msg },
        });
      });
  }, []);

  return <p style={{ padding: '2rem' }}>Completing OAuth flow...</p>;
};

export default OAuthCallback;
